<template>
    <div class="form-body">
        <div v-show="loading != 0" class="row">
            <div class="col-sm-12">
                <h2>{{ trans('form.please_wait') }}...</h2>
                <ring-loader></ring-loader>
            </div>
        </div>
        <div v-show="loading == 0">
            <div class="row">
                <div class="col-sm-6">
                    <singleselect
                            v-model="bagItem.package"
                            name="package"
                            :title="trans('bag_item.entity.package')"
                            :options="packages"
                            :checked="bagItem.package"
                            :errors="form.options.errors"
                            label="name"
                    >
                    </singleselect>
                </div>
                <div class="col-sm-6">
                    <number-input
                            v-model="bagItem.priceBeforeDiscount"
                            name="priceBeforeDiscount"
                            :errors="form.options.errors"
                            :title="trans('bag.entity.price_before_discount')"
                            :disabled="true"
                    >
                    </number-input>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <singleselect
                            v-model="bagItem.variant"
                            v-tooltip="{
                                content: disableMenuChange ? trans('form.errors.time_frame_exceeded') : null,
                                trigger: 'hover',
                                placement: 'top',
                            }"
                            name="variant"
                            :title="trans('bag_item.entity.variant')"
                            :options="variants"
                            :checked="bagItem.variant"
                            :errors="form.options.errors"
                            label="name"
                            :disabled="disableMenuChange"
                    >
                    </singleselect>
                </div>
                <div class="col-sm-6">

                    <text-input
                            v-model="priceDiscountDisplay"
                            name="priceDiscount"
                            :errors="form.options.errors"
                            :title="trans('bag.entity.price_discount')"
                            :disabled="true"
                    >
                    </text-input>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <singleselect
                            v-model="bagItem.mealType"
                            v-tooltip="{
                                content: disableMenuChange ? trans('form.errors.time_frame_exceeded') : null,
                                trigger: 'hover',
                                placement: 'top',
                            }"
                            name="mealType"
                            :title="trans('bag_item.entity.meal_type')"
                            :options="mealTypes"
                            :checked="bagItem.mealType"
                            :errors="form.options.errors"
                            show-route-name="meal_type_show"
                            label="name"
                            :disabled="disableMenuChange"
                            @dispatch="getSizes"
                    >
                    </singleselect>
                </div>
                <div class="col-sm-6">
                    <number-input
                            v-model="bagItem.priceAfterDiscount"
                            name="priceAfterDiscount"
                            :errors="form.options.errors"
                            :title="trans('bag.entity.price_after_discount')"
                            :disabled="true"
                    >
                    </number-input>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <singleselect
                            v-model="bagItem.size"
                            v-tooltip="{
                                content: disableMenuChange ? trans('form.errors.time_frame_exceeded') : null,
                                trigger: 'hover',
                                placement: 'top',
                            }"
                            name="size"
                            :title="trans('bag_item.entity.size')"
                            :options="sizes"
                            :checked="bagItem.size"
                            :errors="form.options.errors"
                            label="name"
                            :disabled="disableMenuChange"
                    >
                    </singleselect>
                </div>
                <div class="col-sm-6">
                    <number-input
                            v-model="bagItem.takenFromMoneyboxPriceChanges"
                            name="takenFromMoneyboxAfterDiscount"
                            :errors="form.options.errors"
                            :title="trans('bag_item.entity.taken_from_moneybox_after_discount')"
                            :step="0.01"
                            :disabled="true"
                    >
                    </number-input>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <singleselect
                            v-model="bagItem.status"
                            v-tooltip="{
                                content: disableResignElement ? trans('form.errors.time_frame_exceeded') : null,
                                trigger: 'hover',
                                placement: 'top',
                            }"
                            name="status"
                            :title="trans('bag_item.entity.status')"
                            :options="statuses"
                            :checked="bagItem.status"
                            :errors="form.options.errors"
                            label="value"
                            show-route-name="tag_show"
                            :disabled="disableResignElement"
                    >
                    </singleselect>
                </div>
                <div class="col-sm-6">
                    <number-input
                            v-model="bagItem.priceTakenFromWalletPriceChanges"
                            name="takenFromWalletAfterDiscount"
                            :errors="form.options.errors"
                            :title="trans('bag_item.entity.taken_from_wallet_after_discount')"
                            :step="0.01"
                            :disabled="true"
                    >
                    </number-input>
                </div>
                <div class="row">
                    <div class="col-sm-6"></div>
                    <div class="col-sm-6">
                        <number-input
                                v-model="bagItem.priceLeftToPayPriceChanges"
                                name="priceLeftToPayPriceChanges"
                                :errors="form.options.errors"
                                :title="trans('order.entity.price_left_to_pay')"
                                :step="0.01"
                                :disabled="true"
                        >
                        </number-input>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">

                </div>
                <div class="col-sm-6">
                    <number-input
                            v-model="bagItem.vatRate"
                            name="vatRate"
                            :errors="form.options.errors"
                            :title="trans('bag_item.entity.vat_rate')"
                    >
                    </number-input>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import toastr from '../toastr'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import TimeFrame from '../mixins/timeframe-mixins'

export default {
  components: {
    Singleselect,
    TextInput,
    NumberInput,
    RingLoader
  },
  mixins: [TimeFrame],
  props: {
    bagItemId: {
      type: [String, Number],
      default: null,
    },
    save: {
      type: Boolean,
      default: false,
    },
    bagVariants: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      loading: 0,
      packages: [],
      mealTypes: [],
      sizes: [],
      statuses: [],
      disableMenuChange: false,
      disableResignElement: false,
      bagItem: {
        id: null,
        bag: null,
        variant: null,
        package: null,
        mealType: null,
        size: null,
        status: null,
        takenFromMoneyboxBeforeDiscount: null,
        takenFromMoneyboxAfterDiscount: null,
        takenFromWalletPriceChanges: null,
        priceTakenFromMoneyboxPriceChanges: null,
        priceLeftToPayPriceChanges: null,
      },
      form: {
        options: {
          errors: {}
        }
      }
    }
  },
  computed: {
    priceDiscountDisplay: {
      set: function () {
      },
      get: function () {
        if (this.bagItem) {
          let percent = Math.round((this.bagItem.priceDiscount / this.bagItem.priceBeforeDiscount) * 100 * 100) / 100

          if (!isNaN(percent)) {
            return `${this.dcNumberFormat(this.bagItem.priceDiscount)} (${this.dcNumberFormat(percent)}%)`
          } else {
            return 0
          }
        }
        return null
      }
    },
    variants() {
      return this.bagItem.package
        ? this.packages.find(el => el.id === this.bagItem.package).variants
        : this.bagVariants;
    }
  },
  watch: {
    'bagItemId': function () {
      this.getBagItem(this.bagItemId)
    },
    'save': function (val) {
      if (val) {
        this.saveBagItem()
      }
    },
    'bagItem.mealType': function (newVal, oldVal) {
      if (newVal && oldVal) {
        this.bagItem.size = null
      }
    }
  },
  mounted: async function () {
    this.getPackages()
    this.getMealTypes()
    this.getStatuses()

    if (this.bagItemId !== null) {
      await this.getBagItem(this.bagItemId)
    }

    await this.validateTimeFrames()
  },
  methods: {
    getBagItem(id) {
      this.loading++

      return new Promise((resolve, reject) => {
        let url = Routing.generate('api_get_bagitem', { 'id': id,
          context: 'bagitem_edit' })

        this.$http.get(url).then(response => {
          this.bagItem = response.data
          this.form.options.errors = {}
          this.loading--
          this.getSizes(this.bagItem.mealType)
          resolve()
        }, response => {
          this.handleAjaxError(response)
          this.loading--
          reject()
        })
      })
    },
    getPackages() {
      this.loading++

      let url = Routing.generate('api_get_packages', {
        context: 'bag_item_edit'
      })

      this.$http.get(url).then(response => {
        this.packages = response.data
        this.loading--
      }, response => {
        this.handleAjaxError(response)
        this.loading--
      })
    },
    getMealTypes() {
      this.loading++

      let url = Routing.generate('api_get_meal_types', {
        context: 'dropdown'
      })

      this.$http.get(url).then(response => {
        this.mealTypes = response.data
        this.loading--
      }, response => {
        this.handleAjaxError(response)
        this.loading--
      })
    },
    getSizes(value) {
      if (value) {
        if (value.id) {
          value = value.id
        }
        this.loading++

        let url = Routing.generate('api_get_sizes_meal_type', {
          context: 'dropdown',
          id: value
        })

        this.$http.get(url).then(response => {
          this.sizes = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      }
    },
    getStatuses() {
      this.loading++

      let url = Routing.generate('api_get_tags', {
        type: 'ecommerce_bag_item_status',
        context: 'dropdown'
      })

      this.$http.get(url).then(response => {
        this.statuses = response.data
        this.loading--
      }, response => {
        this.handleAjaxError(response)
        this.loading--
      })
    },
    trans(name) {
      return Translator.trans(name)
    },
    saveBagItem() {
      let url = Routing.generate('api_patch_bagitem', { id: this.bagItem.id })

      Vue.http.patch(url, {
        'data': this.bagItem
      }).then(() => {
        this.form.options.errors = {}
        toastr.success(Translator.trans('form.updated'))
        this.$emit('bag-item-saved')
      }, response => {
        this.handleAjaxError(response, this.form.options)
        this.$emit('bag-item-save-failed')
      })
    },
    async validateTimeFrames() {
      this.loading++
      this.disableMenuChange = !(await this.validateTimeFrame(this.bagItem.bag.id, 'menuChangeTo'))
      this.disableResignElement = !(await this.validateTimeFrame(this.bagItem.bag.id, 'resignElementTo'))
      this.loading--
    }
  }
}
</script>

<style>
.modal-backdrop.show {
  opacity: .5;
}

div.modal .modal-dialog {
  width: 1200px !important;
}
</style>
